<template>
    <dialog-form
        :value="value"
        @input="$emit('input', $event)"
        @commit="save"
        :title="$localize('AutoRenewLicense.title')"
        :allow-continue="false"
        :action-text="$localize('AutoRenewLicense.title')"
    >
        {{ $localize('AutoRenewLicense.message') }}

        <div class="pt-3">
            Lees onze
            <a target="_new" href="https://torecs.nl/algemene-voorwaarden/"
                >Algemene voorwaarden</a
            >
        </div>
        <v-switch
            :label="$localize('SetupMandate.accept')"
            :hint="$localize('SetupMandate.accept.hint')"
            :rules="[validation.true]"
            persistent-hint
        />
    </dialog-form>
</template>

<script>
import DialogForm from '@/shared/components/DialogForm'
import sendCommand from '@/services/sendCommand'

export default {
    components: { DialogForm },
    props: {
        value: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            validation: {
                true(value) {
                    if (!value) {
                        return 'U moet akkoord gaan met onze algemene voorwaarden'
                    }
                    return true
                },
            },
        }
    },
    methods: {
        async save(callback) {
            const result = await sendCommand('AutoRenewLicense', {})

            if (result.success) {
                this.$emit('saved')
            }

            callback({ success: result.success })
        },
    },
}
</script>
